import React from 'react'
import * as styles from './CorretAnswer.module.scss'
import getClassNameFactory from 'util/getClassNameFactory'
import LegacyRetinaImage from 'components/LegacyRetinaImage'
const getClassName = getClassNameFactory('CorrectAnswer', styles)
const getImageClassName = getClassNameFactory('CorrectAnswerImage', styles)
const getTextClassName = getClassNameFactory('CorrectAnswerText', styles)

export const CorrectAnswer = ({
  answerHasImage,
  correctAnswerText,
  correctAnswerImage,
  correctAnswerCtaText,
  correctAnswerCtaUrl,
  sponsoredType,
}) => {
  return (
    <div
      className={getClassName({
        answerHasImage,
        sponsored: sponsoredType !== 'sponsored',
      })}
    >
      <div className={getTextClassName({ answerHasImage: !!correctAnswerImage })}>
        <span dangerouslySetInnerHTML={{ __html: correctAnswerText }} />
      </div>
      {correctAnswerImage && (
        <div className={getImageClassName({ answerHasImage })}>
          <div className={getClassName('correctAnswerImage')}>
            <LegacyRetinaImage image={correctAnswerImage} />
          </div>
          {correctAnswerCtaText && (
            <button
              className={getClassName('correctAnswerCta')}
              onClick={() => {
                window.open(correctAnswerCtaUrl, '_blank')
              }}
            >
              {correctAnswerCtaText}
            </button>
          )}
        </div>
      )}
    </div>
  )
}
